import React, { useCallback } from "react";
import { formatRelationType } from "utilities";

import type { RelationshipItemProps } from "./entityDetailsPanel.types";

import styles from "./RelationshipItem.module.css";

/** One clickable relationship row: "<Type> → <related entity>". */
const RelationshipItem = ({ onSelect, row }: RelationshipItemProps) => {
	const onClick = useCallback((): void => onSelect(row.relatedEntity), [onSelect, row.relatedEntity]);

	return (
		<li>
			<button className={styles.entityDetailsRelationButton} onClick={onClick} type="button">
				<span className={styles.entityDetailsRelationType}>
					{formatRelationType(row.relationType, row.isEx)}
				</span>
				<span aria-hidden="true">→</span>
				<span className={styles.entityDetailsRelationName}>{row.relatedEntity.title}</span>
			</button>
		</li>
	);
};

export default RelationshipItem;
